import { useEffect, type RefObject } from 'react'

// Mirrors the horizontal scroll offset of `sourceRef` onto `targetRef` as a translateX, so a
// sticky header bar outside the scroller follows the table it labels. No-ops if either ref is empty.
const useSyncedHorizontalScroll = (
  sourceRef: RefObject<HTMLElement | null>,
  targetRef: RefObject<HTMLElement | null>,
) => {
  useEffect(() => {
    const source = sourceRef.current
    const target = targetRef.current
    if (!source || !target) return

    let frame = 0
    const sync = () => {
      if (frame) return
      frame = requestAnimationFrame(() => {
        frame = 0
        target.style.transform = `translateX(${-source.scrollLeft}px)`
      })
    }

    source.addEventListener('scroll', sync, { passive: true })
    return () => {
      source.removeEventListener('scroll', sync)
      if (frame) cancelAnimationFrame(frame)
    }
  }, [sourceRef, targetRef])
}

export default useSyncedHorizontalScroll
